import { useEffect, useRef } from 'react';

const withInfiniteScroll = ({ onScroll }) => {
  const previousElement = useRef(null);
  const observer = useRef(
    new IntersectionObserver(
      (entries) => {
        const [first] = entries;

        if (first.isIntersecting) {
          onScroll();
        }
      },
      {
        root: null,
        rootMargin: '100%',
        threshold: 0.01,
      },
    ),
  );

  const handleElementChange = (element) => {
    if (previousElement.current && previousElement.current !== element) {
      observer.current.unobserve(previousElement.current);
    }

    if (element) {
      observer.current.observe(element);
    }

    previousElement.current = element;
  };

  useEffect(() => {
    return () => {
      if (previousElement.current) {
        observer.current.unobserve(previousElement.current);
        observer.current.disconnect();
      }
    };
  }, []);

  return [handleElementChange];
};

export default withInfiniteScroll;
